enum ContractCancellationTypes {
  Void = 'Void',
  Refund = 'Refund',
}

export default ContractCancellationTypes;
export type VerifyCancellationReason = Utils.VerifyExtends<
  Model.Enum.ContractCancellationTypes,
  Utils.ValueOf<typeof ContractCancellationTypes>
>;
